import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';
import { ValueService } from 'src/app/services/value.service';
import { environment } from 'src/environments/environment';
declare let $: any;
@Component({
  selector: 'app-blog-list',
  templateUrl: './blog-list.component.html',
  styleUrls: ['./blog-list.component.css'],
})
export class BlogListComponent implements OnInit {
  private listApi = environment.url + environment.blogList;
  constructor(private getdata: ValueService, private makeapi: ApiService) {}

  /**
   * Lifecycle hook that is called after Angular has initialized all data-bound properties of a directive.
   * Sets the visibility of the component to true and fetches the list of blogs.
   */
  ngOnInit(): void {
    this.getdata.isVisibleSource.next(true);
    // Fetch the list of blogs
    this.eventList();
  }
  /**
   * Encodes the blog ID and stores it for blog details retrieval.
   * @param id - The ID of the blog to retrieve details for.
   */
  blogGet(id) {
    // Encode the blog ID using base64 encoding
    const encodedId = btoa(id);

    // Store the encoded blog ID for fetching blog details
    this.getdata.blogDetailsId(encodedId);
  }
  list = {};
  disList: any = [];
  pageSize: number = 10;
  pageNumber: number = 1;
  noData = true;
  /**
   * Fetches the list of blogs from the API based on the pagination.
   * Subscribes to the API response and updates the component data.
   * @returns An observable containing the response from the API.
   */
  eventList() {
    // Set the request parameters
    this.list = {
      listSize: this.pageSize,
      pageNumber: this.pageNumber,
    };

    // Call the function to get the list of blogs
    this.ListApi();
  }
  /**
   * Fetches the list of blogs from the API.
   * Subscribes to the API response and updates the component data.
   * @returns An observable containing the response from the API.
   */
  ListApi() {
    this.getdata.amizhthLoader('show');
    // Call the API to fetch the list of blogs
    return this.makeapi
      .method(this.listApi, this.list, 'postunauth')
      .subscribe((data) => {
        this.getdata.amizhthLoader('hide');
        // Check if the response contains any data
        if (data.responsemodelList != undefined) {
          // If there is data, update the component data
          this.noData = false;
          this.numberOfList = data.count;
          this.totalPages = data.totalPages;
          this.countList = data.responsemodelList.length;
          // Calculate the start and end count for the current page
          if (
            this.currentPage == this.totalPages &&
            this.countList != this.numberOfList
          ) {
            this.startCount = this.startCount + this.currentPageCount;
            this.EndCount = this.numberOfList;
          } else if (this.countList == this.numberOfList) {
            this.startCount = 1;
            this.EndCount = this.numberOfList;
          }
          // Update the list of blogs
          this.disList = data.responsemodelList;
          // Set the first carousel item to active
          $(document).ready(function () {
            $('.carosal0').addClass('active');
          });
        } else {
          // If there is no data, show the "No Data" message
          this.noData = true;
        }
      });
  }
  /**
   * Function to calculate the total number of pages based on the count of data.
   * This function is called whenever the data count changes.
   */
  Pagination_Count() {
    this.loading = false;
    // Get the total count of data
    let totalcount = this.numberOfList;
    // Set the total part count to the total count
    this.totalPartCount = totalcount;
    // Calculate the total number of pages by dividing the total count by the current page count
    // and rounding up to the nearest whole number.
    this.totalPages = Math.ceil(this.totalPartCount / this.currentPageCount);
  }
  p1 = 1;
  totalPartCount: any;
  paginationCount = 1;
  currentPageCount = 12;
  loading = false;
  numberOfList = 0;
  currentPage = 1;
  totalPages = 12;
  show_page = false;
  pagecount = 1;
  startCount = 1;
  EndCount = 12;
  countList = 0;
  /**
   * Function to handle pagination.
   * @param page - The page to navigate to. Can be 'prev' or 'next'.
   */
  paginatePartList(page: string) {
    this.show_page = true;
    if (page == 'prev' && this.currentPage > 1) {
      // Decrement the page count
      this.pagecount = this.pagecount - 1;
      // Decrement the current page number
      if (this.currentPage > 1) {
        let prevcount = this.currentPage;
        prevcount--;
        this.paginationCount = prevcount;
        this.currentPage = prevcount;
      } else {
        // If we are at the first page, set the pagination count to 1
        this.paginationCount = 1;
      }
      // Adjust the start and end counts for the new page
      if (this.EndCount != this.numberOfList) {
        this.startCount = this.startCount - this.currentPageCount;
        this.EndCount = this.EndCount - this.currentPageCount;
      } else {
        // If we are at the last page, adjust the start and end counts to the last page
        this.startCount = this.startCount - this.currentPageCount;
        this.EndCount = this.EndCount - this.countList;
      }
    } else {
      // Increment the page count
      this.currentPage = this.currentPage + 1;
      this.pagecount = this.pagecount + 1;
      // Increment the current page number
      if (this.currentPage > 1) {
        let nextcount = this.currentPage - 1;
        nextcount++;
        this.paginationCount = nextcount;
      }
      // Adjust the start and end counts for the new page
      if (this.currentPage != this.totalPages) {
        this.startCount = this.startCount + this.currentPageCount;
        this.EndCount = this.EndCount + this.currentPageCount;
      }
    }
    // Call the event list function to update the list
    this.eventList();
  }
}
